@if (filters) {
    <div class="competition-filters" [class.margin-top]="marginTop">
        @if (isCompetitionsPage) {
            <span
                class="filter-label"
                [class.padding-top]="paddingTop"
                data-crlat="competitionsPageFilterLabel"
                [i18n]="'bma.filters.competitionPage'"></span>
        }
        @if (!isCompetitionsPage) {
            <span class="filter-label" [class.padding-top]="paddingTop" data-crlat="landingPageFilterLabel"></span>
        }

        <div class="scroll-container" [class.padding-top]="paddingTop" [scrollable]>
            @for (filter of filters; track trackByIndex($index)) {
                <competition-filter [filter]="filter" (filterChange)="onFilterChange($event)"></competition-filter>
            }
        </div>
    </div>
}
